(() => {
  const GAP = 40;
  const SWIPE_THRESHOLD = 50;

  const setup = (section) => {
    const tabs = Array.from(section.querySelectorAll('[data-experts-tab]'));
    const panels = Array.from(section.querySelectorAll('[data-experts-panel]'));
    const tabList = section.querySelector('[data-experts-tabs]');
    const viewport = section.querySelector('[data-experts-viewport]');
    const track = section.querySelector('[data-experts-track]');
    if (!tabs.length || !panels.length || !viewport || !track) return;

    let current = 0;

    const offsetFor = (index, drag = 0) => -(index * (viewport.clientWidth + GAP)) + drag;

    const updateHeight = () => {
      const panel = panels[current];
      if (panel) viewport.style.height = `${panel.offsetHeight}px`;
    };

    const centerTab = (tab) => {
      if (!tabList || tabList.scrollWidth <= tabList.clientWidth) return;
      const left = tab.offsetLeft - (tabList.clientWidth - tab.offsetWidth) / 2;
      tabList.scrollTo({ left, behavior: 'smooth' });
    };

    const activate = (index, focusTab = false) => {
      current = Math.max(0, Math.min(index, panels.length - 1));

      tabs.forEach((tab, i) => {
        const active = i === current;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', String(active));
        tab.setAttribute('tabindex', active ? '0' : '-1');
        if (active) {
          centerTab(tab);
          if (focusTab) tab.focus({ preventScroll: true });
        }
      });

      panels.forEach((panel, i) => {
        const active = i === current;
        panel.classList.toggle('is-active', active);
        panel.setAttribute('aria-hidden', String(!active));
        panel.inert = !active;
      });

      track.style.transform = `translateX(${offsetFor(current)}px)`;
      updateHeight();
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(index));
      tab.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let next = index;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        activate(next, true);
      });
    });

    let startX = 0;
    let startY = 0;
    let dragX = 0;
    let dragging = false;
    let locked = null;

    viewport.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      startX = event.clientX;
      startY = event.clientY;
      dragX = 0;
      dragging = true;
      locked = null;
    });

    viewport.addEventListener('pointermove', (event) => {
      if (!dragging) return;
      const dx = event.clientX - startX;
      const dy = event.clientY - startY;
      if (locked === null && (Math.abs(dx) > 6 || Math.abs(dy) > 6)) {
        locked = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
        if (locked === 'x') {
          track.classList.add('is-dragging');
          viewport.setPointerCapture(event.pointerId);
        }
      }
      if (locked !== 'x') return;
      const atEdge = (current === 0 && dx > 0) || (current === panels.length - 1 && dx < 0);
      dragX = atEdge ? dx * 0.3 : dx;
      track.style.transform = `translateX(${offsetFor(current, dragX)}px)`;
    });

    const endDrag = () => {
      if (!dragging) return;
      dragging = false;
      track.classList.remove('is-dragging');
      if (locked === 'x') {
        if (dragX <= -SWIPE_THRESHOLD) activate(current + 1);
        else if (dragX >= SWIPE_THRESHOLD) activate(current - 1);
        else activate(current);
      }
      locked = null;
      dragX = 0;
    };

    viewport.addEventListener('pointerup', endDrag);
    viewport.addEventListener('pointercancel', endDrag);
    viewport.addEventListener('dragstart', (event) => event.preventDefault());

    panels.forEach((panel) => {
      panel.querySelectorAll('img').forEach((img) => {
        if (!img.complete) img.addEventListener('load', updateHeight, { once: true });
      });
    });

    let lastWidth = viewport.clientWidth;
    const onResize = () => {
      if (viewport.clientWidth === lastWidth) {
        updateHeight();
        return;
      }
      lastWidth = viewport.clientWidth;
      track.classList.add('is-dragging');
      track.style.transform = `translateX(${offsetFor(current)}px)`;
      updateHeight();
      requestAnimationFrame(() => track.classList.remove('is-dragging'));
    };
    window.addEventListener('resize', onResize, { passive: true });

    activate(0);
  };

  const init = () => {
    document.querySelectorAll('[data-pdp-re-experts]:not([data-pdp-re-experts-ready])').forEach((section) => {
      section.setAttribute('data-pdp-re-experts-ready', 'true');
      setup(section);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();